// 'catchAll' locale is currently a workaround to allow URL prefix for the default locale
// See https://github.com/vercel/next.js/discussions/18419#discussioncomment-327128

const ES_US_LOCALE = 'es-US'

module.exports = {
  ES_US_LOCALE,
  supportedLocales: ['en-AU', 'en-NZ', 'en-US', 'en-GB', 'en-CA', 'fr-CA', ES_US_LOCALE, 'catchAll'],
}
